// src/components/Subscription/SubscriptionModal.jsx
import React, { useEffect, useState } from 'react';
import { Modal, Form, Select, DatePicker, InputNumber, Switch, Input } from 'antd';
import dayjs from 'dayjs';
import { getActiveCustomers } from '../../customer/service';
import { getActiveProducts } from '../../product/service';
// import { CUSTOMER, PRODUCTS } from '../constants';

const SubscriptionModal = ({ visible, onCancel, onSave, initialData }) => {

  const subscriptionFields = [
    {
      name: 'product_id',
      label: 'Product',
      type: 'select',
      rules: [{ required: true, message: 'Select the Product' }],
    },
    {
      name: 'customer_id',
      label: 'Customer',
      type: 'select',
      rules: [{ required: true, message: 'Select the Customer' }],
    },
    {
      name: 'start_date',
      label: 'Start Date',
      type: 'date',
      rules: [{ required: true, message: 'Please select the Start Date!' }],
    },
    {
      name: 'end_date',
      label: 'End Date',
      type: 'date',
      rules: [{ required: true, message: 'Please select the End Date!' }],
    },
    {
      name: 'amount',
      label: 'Amount',
      type: 'number',
      rules: [
        { required: true, message: 'Please enter the amount!' },
        { type: 'number', min: 0, message: 'Amount must be positive' },
      ],
    },
    {
      name: 'is_active',
      label: 'Active',
      type: 'switch',
      valuePropName: 'checked', // Important for Switch
    },
  ];

  const [form] = Form.useForm();
  const [products, setProducts] = useState([]);
  const [customers, setCustomers] = useState([]);

  const fetchProducts = async () => {
    try {
      const data = await getActiveProducts();
      return data;
    } catch (error) {
      console.error('Failed to fetch products', error);
      // return PRODUCTS;
    } finally {
      console.error('Failed to fetch products');
    }
  };

  const fetchCustomers = async () => {
    try {
      const data = await getActiveCustomers();
      return data;
    } catch (error) {
      console.error('Failed to fetch products', error);
      // return CUSTOMER;
    } finally {
      console.error('Failed to fetch products');
    }
  };

  useEffect(() => {
    const loadData = async () => {
      const [productRes, customerRes] = await Promise.all([
        fetchProducts(),
        fetchCustomers(),
      ]);
      setProducts(productRes);
      setCustomers(customerRes);
    };
    if(visible) {
      loadData();
    }
  }, [visible]);

  useEffect(() => {
    if (initialData) {
      form.setFieldsValue({
        ...initialData,
        product_id: initialData?.product?.name || '',
        customer_id: initialData?.customer?.name || '',
        start_date: dayjs(initialData.start_date),
        end_date: dayjs(initialData.end_date),
      });
    } else {
      form.resetFields();
    }
  }, [initialData, form]);

  const handleOk = async () => {
    const values = await form.validateFields();
    onSave({
      ...values,
      start_date: values.start_date.format('YYYY-MM-DD'),
      end_date: values.end_date.format('YYYY-MM-DD'),
    });
  };

  const renderField = (field) => {
    switch (field.type) {
      case 'select':
        const options = field.name === 'product_id' ? products : customers;
        const skuOrCode = field.name === 'product_id' ? 'sku' : 'code';
        return (
          <Select placeholder={`Select ${field.label}`}>
            {options.map(item => (
              <Select.Option key={item.id} value={item.id}>
                {item.name} ({item[skuOrCode]})
              </Select.Option>
            ))}
          </Select>
        );
      case 'date':
        return <DatePicker style={{ width: '100%' }}/>;
      case 'number':
        return <InputNumber style={{ width: '100%' }} step={0.01} />;
      case 'switch':
        return <Switch />;
      default:
        return <Input />;
    }
  };

  return (
    <Modal
      title={initialData ? 'Edit Subscription' : 'New Subscription'}
      open={visible}
      onCancel={onCancel}
      onOk={handleOk}
      okText="Save"
    >
      <Form form={form} layout="vertical" initialValues={{ is_active: true }}>
        {subscriptionFields.map(field => (
          <Form.Item
            key={field.name}
            name={field.name}
            label={field.label}
            rules={field.rules}
            valuePropName={field.valuePropName || 'value'}
          >
            {renderField(field)}
          </Form.Item>
        ))}
      </Form>
    </Modal>
  );
};

export default SubscriptionModal;
